import { APPLE_APP_STORE_ID } from '../links/apple-app-store-id';
import { buildAppDownloadWebUrl } from '../links/build-app-download-web-url';
import { siteUrl } from '../site/metadata';

export const androidPackageId = 'com.yocoolmate.app';
export const cafeBazaarPackageId = `${androidPackageId}.cafebazaar`;
export const myketPackageId = `${androidPackageId}.myket`;
export const appDownloadUrl = buildAppDownloadWebUrl();
export const appleAppStoreUrl = `https://apps.apple.com/us/app/cool-mate-learn-english/id${APPLE_APP_STORE_ID}`;
export const googlePlayUrl = `https://play.google.com/store/apps/details?id=${androidPackageId}`;
export const cafeBazaarAppUrl = `https://cafebazaar.ir/app/${cafeBazaarPackageId}`;
export const myketAppUrl = `https://myket.ir/app/${myketPackageId}`;
export const telegramBotPath = '/tg';
export const telegramBotUrl = `${siteUrl}${telegramBotPath}`;
export const telegramBotExternalUrl = 'https://t.me/coolmaterobot';
